import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BackgroundUsageHistory from '../../../domain/entities/BackgroundUsageHistory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexBackgroundUsageHistoriesSuccess: {
      const result = action.payload as PaginatedResult<BackgroundUsageHistory>;
      return mergeResponse(state, result);
    }
    case Types.UpdateBackgroundUsageHistorySuccess: {
      const backgroundUsageHistory = action.payload as BackgroundUsageHistory;
      const newState = {} as QueryState;
      Object.keys(state).forEach(stateKey => {
        const response = {...state[stateKey]};
        const filteredIds = response.pageToIds[1].filter(
          id => id !== backgroundUsageHistory.id,
        );
        if (stateKey.includes(`"storyId":${backgroundUsageHistory.storyId}`)) {
          response.pageToIds[1] = [backgroundUsageHistory.id, ...filteredIds];
        }
        newState[stateKey] = response;
      });
      return newState;
    }
    default:
      return state;
  }
}
